import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

export const generalInfoState = (state: RootState) => state.generalInfo.generalInfoDetail;
export const generalInfoSearchState = (state: RootState) => state.generalInfo.searchValue;

export const selectGeneralInfoByBabyBook = (babyBookId?: string) =>
  createSelector(generalInfoState, (info) => (babyBookId ? info[babyBookId] : undefined));
